import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import { Error, Loading } from "ra-ui-materialui";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { useContext, useEffect, useState } from "react";

import CartPanel from "../../../components/CartPanel";
import Cash from "./payment-method-page/Cash";
import CreditDebit from "./payment-method-page/Card/CreditDebit";
import GridMenu from "./GridMenu";
import InputMoneyTextField from "./payment-method-page/Widget/InputMoneyTextField";
import MasterLayoutContainer from "../../../components/MasterLayoutContainer";
import PaymentConfirm from "./payment-method-page/PaymentConfirm/PaymentConfirm";
import { PaymentCreateContext } from "../payment-addproduct/PaymentCreateContext";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import SimpleSplitPayment from "./simple-split-payment";
import TransferPage from "./payment-method-page/Transfer/TransferPage";
import cardIcon from "../../../assets/icons/paymentIcon/disabledIcon/Credit.png";
import cashIcon from "../../../assets/icons/paymentIcon/disabledIcon/Cash.png";
import { createPaymentTransaction } from "../../../hooks/useMakeaPayment";
import enableTransferIcon from "../../../assets/icons/paymentIcon/enableIcon/Transfer.png";
import enablecardIcon from "../../../assets/icons/paymentIcon/enableIcon/Credit.png";
import enablecashIcon from "../../../assets/icons/paymentIcon/enableIcon/Cash.png";
import enablesplitPayment from "../../../assets/icons/paymentIcon/enableIcon/Split.png";
import { isPaymentCardType } from "../../../utils";
import splitPayment from "../../../assets/icons/paymentIcon/disabledIcon/Split.png";
import transferIcon from "../../../assets/icons/paymentIcon/disabledIcon/Transfer.png";
import { useLocale } from "ra-core";
import usePaymentMethods from "../../../hooks/usePaymentMethods";
import { useTranslate } from "react-admin";

// import bWalletIcon from "../../../assets/icons/paymentIcon/disabledIcon/BWallet.png";

// import truemoney from "../../../assets/icons/paymentIcon/disabledIcon/Truewallet.png";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    height: "100%",
    backgroundColor: theme.layout.main.backgroundColor,
  },
  leftPanel: {
    width: "100%",
    height: "100%",
    overflow: "auto",
    display: "flex",
    backgroundColor: theme.layout.leftPanel.backgroundColor,
    zIndex: 0,
  },
  rightPanel: {
    width: "100%",
    paddingTop: 0,
    paddingLeft: 0,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.layout.rightPanel.backgroundColor,
    overflow: "auto",
    height: "100%",
    zIndex: 1,
  },
  backgroundPaper: {
    flex: 2,
    margin: "0px auto 10px",
    backgroundColor: theme.lightGray,
    height: 0,
  },
  containerToggleButton: {
    display: "flex",
    margin: " 0 20px",
  },

  toggleButton: {
    flex: "1",
    marginTop: "15px",
    color: theme.white,
    fontSize: 16,
    height: 38,
  },

  container: {
    width: 138 * 3 + 80,
    // backgroundColor: "red",
    display: "grid",
    gridTemplateColumns: "33% 33% 33%",
    margin: " 0px auto",
  },
  bottomToggleButton: {},
  textTitle: {
    marginLeft: 29,
    marginTop: 10,
    fontSize: 20,
  },
}));

const PaymentMethod = () => {
  const classes = useStyles();
  const [fullPaymentBeforeChange, setFullPaymentBeforeChange] = useState(0);
  return (
    <MasterLayoutContainer>
      <Grid container className={classes.allContainer}>
        <Grid item xs={12} sm={8} className={classes.leftPanel}>
          <LeftPanel
            fullPaymentBeforeChange={fullPaymentBeforeChange}
            setFullPaymentBeforeChange={setFullPaymentBeforeChange}
          />
        </Grid>
        <Grid item xs={12} sm={4} className={classes.rightPanel}>
          {<CartPanel />}
        </Grid>
        <PaymentConfirm fullPaymentBeforeChange={fullPaymentBeforeChange} />
      </Grid>
    </MasterLayoutContainer>
  );
};

/** This will include delivery cost to PaymentTransaction */
const LeftPanel = ({ fullPaymentBeforeChange, setFullPaymentBeforeChange }) => {
  const classes = useStyles();
  const [state, dispatch] = useContext(PaymentCreateContext);
  const locale = useLocale();
  const paymentTransaction = createPaymentTransaction(state, locale);
  const { paymentMethods, error, loading } = usePaymentMethods();
  const [bottomToggleButtonValue, setBottomToggleValue] = useState("");
  const [openTransferDialog, setTransferDialogOpen] = useState(false);
  const [openSplitDialog, setSplitDialogOpen] = useState(false);
  const [openCardDialog, setOpenCardDialog] = useState(false);
  const [openCashDialog, setOpenCashDialog] = useState(false);
  const [topToggleButtonValue, setTopToggleValue] = useState("Full Payment");

  const translate = useTranslate();
  console.log(paymentTransaction);
  const [paymentValue] = useState(
    paymentTransaction.summary?.total_revenue ?? 0 /*+
       (paymentTransaction.delivery_cost ?? 0)*/
  );

  useEffect(() => {
    if (paymentTransaction.summary?.total_revenue === 0) {
      handleBottomToggleValue("Other");
      handleClickDialogOpen("Other");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTopToggleValue = (_, newValue) => {
    if (newValue) {
      setTopToggleValue(newValue);
    }
  };

  const handleBottomToggleValue = (newValue) => {
    if (bottomToggleButtonValue === newValue) {
      //setBottomToggleValue(""); Do nothing
    } else {
      setBottomToggleValue(newValue);
    }
  };

  const handleClickDialogOpen = (name) => {
    if (name === "Cash") {
      //Do Full Cash payment
      setOpenCashDialog(true);
      return dispatch({
        type: "SET_PAYMENT_CHANNEL",
        payload: {
          type: "Cash",
          amount: paymentValue,
        },
      });
    }
    if (name === "Other") {
      return dispatch({
        type: "SET_PAYMENT_CHANNEL",
        payload: {
          type: "Other",
          amount: paymentValue,
        },
      });
    }
    if (isPaymentCardType(name)) {
      return setOpenCardDialog(true);
    }
    if (name === "Transfer") {
      return setTransferDialogOpen(true);
    }
    if (name === "Split Payment") {
      return setSplitDialogOpen(true);
    }
  };

  function handleDialogClose(name) {
    if (name === "Cash") {
      setOpenCashDialog(false);
    }
    if (isPaymentCardType(name)) setOpenCardDialog(false);

    if (name === "Transfer") {
      setTransferDialogOpen(false);
    }
    if (name === "Split Payment") {
      setSplitDialogOpen(false);
    }
    setBottomToggleValue("");
    dispatch({
      type: "REMOVE_PAYMENT_CHANNEL",
    });
  }

  if (loading) return <Loading />;

  if (error) return <Error error={error} />;

  let completePaymentMethods = paymentMethods.map((pMethod) => {
    if (pMethod.name === "Cash") {
      return {
        disabledIcon: cashIcon,
        enabledIcon: enablecashIcon,
        name: "Cash", //Also used as value
        disabled: paymentValue === 0 ? true : false,
        label: translate("ra.text.paymentMethod.cash"), //to display in button
      };
    }

    if (isPaymentCardType(pMethod.name)) {
      return {
        disabledIcon: cardIcon,
        enabledIcon: enablecardIcon,
        name: "Credit / Debit Card",
        disabled: paymentValue === 0 ? true : false,
        label: translate("ra.text.paymentMethod.card"), //to display in button
      };
    }

    if (pMethod.name === "Transfer") {
      return {
        disabledIcon: transferIcon,
        enabledIcon: enableTransferIcon,
        name: "Transfer",
        disabled: paymentValue === 0 ? true : false,
        label: translate("ra.text.paymentMethod.transfer"), //to display in button
      };
    }
    return {
      disabledIcon: null,
      enabledIcon: null,
      name: pMethod.name,
      disabled: false,
      label: pMethod.name,
    };
  });

  //Split payment button
  if (completePaymentMethods.length > 1) {
    // completePaymentMethods.push({
    //   disabledIcon: splitPayment,
    //   enabledIcon: enablesplitPayment,
    //   name: "Split Payment",
    //   disabled: paymentValue === 0 ? true : false,
    //   label: translate("ra.text.paymentMethod.split"), //to display in button
    // });

    completePaymentMethods.push({
      disabledIcon: null,
      enabledIcon: null,
      name: "Other",
      disabled: false,
      label: translate("ra.text.paymentMethod.other"), //to display in button
    });
  }

  return (
    <>
      <Box style={{ display: "flex", width: "100%" }}>
        <Box classes={{ root: classes.backgroundPaper }} elevation>
          <SfBreadcrumbs
            path="/Payment/&user/Add Product/Payment Method"
            lower
          />
          <Typography className={classes.textTitle}>
            1. {translate("ra.text.paymentOption.selectPayment")}
          </Typography>

          <Box>
            <ToggleButtonGroup
              value={topToggleButtonValue}
              exclusive
              onChange={handleTopToggleValue}
              classes={{ root: classes.containerToggleButton }}
            >
              <ToggleButton
                value="Full Payment"
                aria-label="percent"
                classes={{
                  root: classes.toggleButton,
                  selected: classes.selectedButton,
                }}
              >
                {translate("ra.text.paymentOption.selectPayment")}
              </ToggleButton>

              <ToggleButton
                value="Deposit"
                aria-label="deposit"
                classes={{
                  root: classes.toggleButton,
                  selected: classes.selectedButton,
                }}
                disabled
              >
                {translate("ra.text.paymentOption.deposit")}
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <InputMoneyTextField
            disabled
            value={paymentValue + (paymentTransaction.delivery_cost ?? 0)}
          />

          <Typography className={classes.textTitle}>
            2. {translate("ra.text.paymentOption.selectPaymentMethod")}
          </Typography>

          <ToggleButtonGroup
            value={bottomToggleButtonValue}
            // exclusive
            classes={{ root: classes.container }}
          >
            {completePaymentMethods.map((pMethod, index) => {
              return (
                <GridMenu
                  key={index}
                  nameOfButton={pMethod.label}
                  icon={
                    bottomToggleButtonValue === pMethod.name
                      ? pMethod.enabledIcon
                      : pMethod.disabledIcon
                  }
                  disabled={pMethod.disabled}
                  value={pMethod.name}
                  onClick={() => {
                    handleBottomToggleValue(pMethod.name);
                    handleClickDialogOpen(pMethod.name);
                  }}
                  selected={bottomToggleButtonValue === pMethod.name}
                />
              );
            })}
          </ToggleButtonGroup>
          {/* </Box> */}
        </Box>
      </Box>
      <CreditDebit
        paymentValue={paymentValue}
        openDialog={openCardDialog}
        handleDialogClose={() => handleDialogClose("Credit / Debit Card")}
        onSubmit={(card) => {
          dispatch({ type: "SET_PAYMENT_CHANNEL", payload: card });
          setOpenCardDialog(false);
        }}
      />
      <TransferPage
        paymentValue={paymentValue}
        openDialog={openTransferDialog}
        handleDialogClose={() => handleDialogClose("Transfer")}
        onSubmit={(bank) => {
          dispatch({ type: "SET_PAYMENT_CHANNEL", payload: bank });
          setTransferDialogOpen(false);
        }}
      />
      <Cash
        openDialog={openCashDialog}
        onClose={() => handleDialogClose("Cash")}
        onSubmit={() => setOpenCashDialog(false)}
        cashValue={paymentValue + (paymentTransaction.delivery_cost ?? 0)}
        fullPaymentBeforeChange={fullPaymentBeforeChange}
        setFullPaymentBeforeChange={setFullPaymentBeforeChange}
      />
      <SimpleSplitPayment
        openDialog={openSplitDialog}
        onClose={() => handleDialogClose("Split Payment")}
        paymentValue={paymentValue}
        onSubmit={(payments) => {
          dispatch({ type: "SET_PAYMENT_CHANNELS", payload: payments });
          setSplitDialogOpen(false);
        }}
      ></SimpleSplitPayment>
    </>
  );
};
export default PaymentMethod;
